import toolIndex from "toolConstants";
import { findKey, values } from "lodash";

export const acousticsReducers = {
  /**
   * Sets the noise level.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {string|number} action.payload - The new noise level or profile.
   */
  setNoiseLevel: (state: any, action: any) => {
    const value = action.payload;
    const noiseProfiles = toolIndex[state.currentTool].constants.noiseProfiles;
    if (value in noiseProfiles) {
      state.areas[state.activeTab].noiseLevel = noiseProfiles[value];
    } else if (value) {
      state.areas[state.activeTab].noiseLevel = value;
      state.areas[state.activeTab].backgroundNoise = null;
    }
    const noise = findKey(noiseProfiles, key => key === value);
    if (noise) state.areas[state.activeTab].backgroundNoise = noise;
  },

  /**
   * Sets the materials for walls and ceiling.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {Object} action.payload - The new materials.
   * @param {string} [action.payload.walls] - The wall material.
   * @param {string} [action.payload.ceiling] - The ceiling material.
   */
  setMaterials: (state: any, action: any) => {
    const currentArea = state.areas[state.activeTab];
    if (currentArea) {
      currentArea.materials = { ...currentArea.materials, ...action.payload };
    } else {
      state.materials = { ...state.materials, ...action.payload };
      values(state.areas).forEach((area: any) => {
        if (area.openCeiling) area.materials = { ...area.materials, ...action.payload }
      })
    };
  },

  /**
   * Sets the system primary usage for the current area.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {string} action.payload - The new system primary usage.
   */
  setSystemPrimaryUsage: (state: any, action: any) => {
    state.areas[state.activeTab].systemPrimaryUsage = action.payload;
    if (!state.areas[state.activeTab].customized.speakerModel) {
      state.areas[state.activeTab].speakerModel = null;
    }
  },

  /**
   * Sets the budget for the current area or container.
   * @param {Object} state - The current state.
   * @param {Object} action - The action object.
   * @param {string} action.payload - The new budget level.
   */
  setBudget: (state: any, action: any) => {
    (state.areas[state.activeTab] || state).budget = action.payload;
    if (!state.areas[state.activeTab].customized.speakerModel) {
      state.areas[state.activeTab].speakerModel = null;
    }
  },
};
